import * as R from 'ramda'
import * as recompose from 'recompose'
import querystring from 'querystring'
import url from 'url'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import * as session from '../session'
import * as configuration from '../configuration'
import { ClientType } from '../constants'

import { GameLauncher as Component } from './game-launcher'

const ENVS = {
  staging: 'stg',
  production: 'prd',
}

const connector = R.compose(
  withRouter,
  connect((state, props) => {
    const gameId = props.match?.params?.gameId || props.gameId
    const freeGames = R.path(
      ['free_games'],
      querystring.parse(R.drop(1, props.location.search))
    )

    const brand = configuration.getBrand(state.configuration)
    const clientType = configuration.getClientType(state.configuration)
    const env = R.prop(configuration.getEnvironment(state.configuration), ENVS)
    const gameServerUrl = configuration.getGameServerUrl(state.configuration)

    const gameUrl = url.format({
      pathname: `/games/${gameId}`,
      query: {
        brand,
        client_type: clientType,
        env: env,
        free_games: freeGames,
        language: configuration.getLanguage(state.configuration),
        mode: props.mode,
        token: session.getToken(state.session),
      },
    })

    return {
      gameUrl: R.not(R.equals(clientType, ClientType.UNKNOWN))
        ? `${gameServerUrl}${gameUrl}`
        : null,
    }
  }),
  recompose.branch(props => R.isNil(props.gameUrl), recompose.renderNothing)
)

export const GameLauncher = connector(Component)
